module.exports = __webpack_public_path__ + "img/wrapper_bg.67d9d55.webp";